export enum SpectralService {
  Mobile = 0,
  VisionMachine = 1,
  Desktop = 2
}

export enum LicenseStatus {
  Invalid = 0,
  Valid = 1,
  Expired = 2,
  ExpiringSoon = 3,
}

export interface LicenseFilter {
  service: SpectralService | null,
  status: LicenseStatus | null,
  name: string | null, 
  users: string[] | null,
}

export default interface License {
  rowKey: string;
  timestamp: Date;
  updatedAt: Date;
  name: string;
  description: string;
  daysToExpire: number;
  status: LicenseStatus;
  price: number;
  expiresAt: Date;
  validationToken: string;
  service: SpectralService;
  users: string;
  isDeviceRestrict: boolean;
  devices: string;
  isModelRestrict: boolean;
  models: string;
  computerMac: string;
  isActive: boolean;
}